import { useContext } from 'react'

import { ExportPptxDataContext } from '../contexts/ExportPptxContext'

export const useExportPptxData = () => {
  return useContext(ExportPptxDataContext)
}
